import { useState } from 'react';
import { narratorUrl } from '../art/assets';

interface Props {
  expression?: string;
  glitch?: boolean;
}

/** Painted narrator bust that swaps expression per outcome. Falls back to the gradient disc. */
export function NarratorPortrait({ expression, glitch }: Props) {
  const url = narratorUrl(expression);
  const [failed, setFailed] = useState<string | null>(null);
  const showImg = url && failed !== url;
  return (
    <div
      className={`narrator-portrait ${showImg ? 'narrator-portrait--art' : ''} ${glitch ? 'narrator-portrait--glitch' : ''}`}
      data-expression={expression ?? 'neutral'}
      aria-hidden="true"
    >
      {showImg && <img key={url} src={url} alt="" onError={() => setFailed(url)} draggable={false} />}
    </div>
  );
}
